import React, { createContext, useContext, useEffect, useState } from "react";

const CurrencyContext = createContext({
  currency: "inr",
  setCurrency: () => {},
});

const STORAGE_KEY = "hob_currency";

const getInitial = () => {
  if (typeof window === "undefined") return "inr";
  const saved = window.localStorage.getItem(STORAGE_KEY);
  return saved === "inr" || saved === "usd" ? saved : "inr";
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(getInitial);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, currency);
  }, [currency]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);

export default CurrencyContext;
